export default __webpack_public_path__ + "static/media/sticker.c70c7ff2.svg";